import { REDUX_LOCAL_KEY_PREFIX } from '../../constants/local-key'

function getLocalKeysReduxUtil (instance) {
  const localKeys = []
  if (!instance) {
    return localKeys
  }
  return [
    ...localKeys,
    ...Object
      .keys(instance.changed || {})
      .filter(key => {
        return key.includes(REDUX_LOCAL_KEY_PREFIX)
      })
  ]
}

export default getLocalKeysReduxUtil
